/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function varieties(instance) {
	return {
		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (id, config = {}) => {
			return instance.get(`varieties/${id}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`varieties${params}`, config)
		},

		/**
		 * @param {number} id
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (id, body, config = {}) => {
			return instance.put(`varieties/${id}`, body, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (id, config = {}) => {
			return instance.delete(`varieties/${id}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('varieties', body, config)
		}
	}
}
